import Vue from 'vue'
export const DataFilterBus = new Vue()

export const applyDataFilters = (filterName, ...args) => {
  DataFilterBus.$emit(filterName, ...args)
}
export const addDataFilter = (filterName, callback) => {
  DataFilterBus.$on(filterName, callback)
}

Vue.prototype.$$addDataFilter = addDataFilter
Vue.prototype.$$applyDataFilters = applyDataFilters

export default {
  add: addDataFilter,
  apply: applyDataFilters
}
